import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const StickyElement = forwardRef(({ children, className, useFixed }, ref) => {
  return (
    <div
      ref={ref}
      className={className}
      style={{
        position: useFixed ? "fixed" : "sticky",
        top: 0,
        width: '100%',
        zIndex: 1020,
      }}
    >
      {children}
    </div>
  );
});

StickyElement.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  useFixed: PropTypes.bool,
};

export default StickyElement;
